import { GlobalPeriodSelect } from '@components'

import { Button, notify, Text } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { NotificationKeys } from '../../../../enums/notificationKeys'
import { usePeriodDates } from '../../../../hooks/usePeriodDates'
import { PeriodValue } from '../../../../types/periodValue'
import { useExportFecReport } from '../../hooks/useExportFecReport'
import { useExportsPeriodValue } from '../../hooks/useExportsPeriodValue'
import { ExportsCard } from '../ExportsCard'

export const FecReport = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { encodedPeriodValue, setPeriod } = useExportsPeriodValue()
  const { fromDate, toDate } = usePeriodDates(encodedPeriodValue)

  const { mutate, isLoading } = useExportFecReport({
    onSuccess: () => {
      notify({
        id: NotificationKeys.ExportsFecReportSend,
        message: t('exports.card.fec_report.sent.notification.success'),
        variant: 'success',
      })
    },
    onError: () => {
      notify({
        id: NotificationKeys.ExportsFecReportSend,
        message: t('exports.card.fec_report.sent.notification.error'),
        variant: 'error',
      })
    },
  })

  const organizationId = organization?.id

  const handleClickExport = useCallback(() => {
    if (!organizationId) {
      return
    }

    if (fromDate && toDate) {
      mutate({
        organizationId,
        fromDate,
        toDate,
      })
    }
  }, [fromDate, mutate, organizationId, toDate])

  const handleChangePeriod = useCallback(
    (newPeriod: PeriodValue) => {
      setPeriod(newPeriod)
    },
    [setPeriod],
  )

  return (
    <ExportsCard
      description={t('exports.card.fec_report.description')}
      title={t('exports.card.fec_report.title')}
      actionButton={
        <Button onClick={handleClickExport} fullWidth disabled={isLoading} loading={isLoading} variant="outlined">
          {t('exports.card.fec_report.button.label')}
        </Button>
      }
    >
      <div>
        <Text colorVariant="label" weight="medium">
          {t('exports.period')}
        </Text>
        <GlobalPeriodSelect encodedPeriod={encodedPeriodValue} onChange={handleChangePeriod} fullWidth />
      </div>
    </ExportsCard>
  )
}
